export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-black border-t border-[var(--pd-border)] py-16"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 md:grid-cols-3 gap-12 items-start">
        <div>
          <p className="font-serif-display text-2xl md:text-3xl text-white tracking-[0.18em]">PiérrecDavís</p>
          <p className="mt-4 text-white/55 text-sm leading-relaxed max-w-sm">
            Private haute horlogerie and fine jewelry. Pieces by invitation, never by inventory.
          </p>
        </div>
        <div>
          <p className="eyebrow">The Maison</p>
          <ul className="mt-5 space-y-3 text-white/65 text-sm">
            <li>Monaco · Geneva</li>
            <li>Private appointments worldwide</li>
            <li>By introduction or invitation</li>
          </ul>
        </div>
        <div>
          <p className="eyebrow">Concierge</p>
          <ul className="mt-5 space-y-3 text-white/65 text-sm">
            <li><a href="/ultra-fine-jewelry" className="hover:text-[var(--pd-gold)] transition-colors" data-testid="footer-link-ultra-fine">Ultra Fine Jewelry</a></li>
            <li><a href="#invitation" className="hover:text-[var(--pd-gold)] transition-colors" data-testid="footer-link-invitation">Request Invitation</a></li>
            <li><a href="#acquisitions" className="hover:text-[var(--pd-gold)] transition-colors" data-testid="footer-link-acquisitions">Private Acquisitions</a></li>
            <li><a href="#monaco" className="hover:text-[var(--pd-gold)] transition-colors" data-testid="footer-link-monaco">Monaco '26</a></li>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="text-white/40 text-[0.65rem] uppercase tracking-[0.4em]">
          © {new Date().getFullYear()} PiérrecDavís Maison
        </p>
        <p className="text-white/40 text-[0.65rem] uppercase tracking-[0.4em]">
          Rise Above The Ordinary
        </p>
      </div>
    </footer>
  );
}
